export default {
  header: 'Ein Mitarbeiter muss den Code eingeben',
  error_codes: {
    403: 'Falscher Passcode',
    default: 'Da ist was schief gelaufen. Bitte versuche es erneut oder überprüfe die Internetverbindung.',
  },
};
